// extracted by mini-css-extract-plugin
module.exports = {"filters":"search-filters-wrapper_filters__fA7HY","filtersShadow":"search-filters-wrapper_filtersShadow___n40v"};